import React, { useEffect, useState } from 'react';

type TypedValueProps = {
  /** Texte final à "taper". Vide = rien n'est affiché (placeholder géré par le parent). */
  text: string;
  /** Délai entre deux caractères en ms */
  speed?: number;
  /** Masquer les caractères (mot de passe) */
  mask?: boolean;
  className?: string;
  onDone?: () => void;
};

/**
 * Effet machine à écrire : tape `text` caractère par caractère à chaque changement de valeur.
 */
const TypedValue: React.FC<TypedValueProps> = ({ text, speed = 45, mask = false, className, onDone }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(0);
    if (!text) return;
    let i = 0;
    const id = window.setInterval(() => {
      i += 1;
      setCount(i);
      if (i >= text.length) {
        window.clearInterval(id);
        onDone?.();
      }
    }, speed);
    return () => window.clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, speed]);

  if (!text) return null;
  const shown = text.slice(0, count);
  const done = count >= text.length;

  return (
    <span className={`ts-typed ${done ? 'is-done' : ''} ${className || ''}`}>
      {mask ? '•'.repeat(shown.length) : shown}
      <span className="ts-caret" aria-hidden="true" />
    </span>
  );
};

export default TypedValue;
